(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ventamesdia', {
            parent: 'entity',
            url: '/ventamesdia',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ventamesdia.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ventamesdia/ventamesdias.html',
                    controller: 'VentamesdiaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ventamesdia');
					$translatePartialLoader.addPart('zeta'); 
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ventamesdia-detail', {
            parent: 'ventamesdia',
            url: '/ventamesdia/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'mVtasWebApp.ventamesdia.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ventamesdia/ventamesdia-detail.html',
                    controller: 'VentamesdiaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ventamesdia');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Ventamesdia', function($stateParams, Ventamesdia) {
                    return Ventamesdia.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ventamesdia',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ventamesdia-detail.edit', {
            parent: 'ventamesdia-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventamesdia/ventamesdia-dialog.html',
                    controller: 'VentamesdiaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ventamesdia', function(Ventamesdia) {
                            return Ventamesdia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ventamesdia.new', {
            parent: 'ventamesdia',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventamesdia/ventamesdia-dialog.html',
                    controller: 'VentamesdiaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fecha: null,
                                razonsocial: null,
                                comercio: null,
                                nrolocal: null,
                                contrato: null,
                                total: null,
                                tickets: null,
								items: null,
								tax1a: null,
                                tax1b: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ventamesdia', null, { reload: 'ventamesdia' });
                }, function() {
                    $state.go('ventamesdia');
                });
            }]
        })
        .state('ventamesdia.edit', {
            parent: 'ventamesdia',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventamesdia/ventamesdia-dialog.html',
                    controller: 'VentamesdiaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ventamesdia', function(Ventamesdia) {
                            return Ventamesdia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ventamesdia', null, { reload: 'ventamesdia' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ventamesdia.delete', {
            parent: 'ventamesdia',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ventamesdia/ventamesdia-delete-dialog.html',
                    controller: 'VentamesdiaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Ventamesdia', function(Ventamesdia) {
                            return Ventamesdia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ventamesdia', null, { reload: 'ventamesdia' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
